<template>
  <div class="splitTipPopover" v-show="visible" @click.stop>
    <div class="tiptitle">确认拆分此订单吗？</div>
    <div class="y-fc-F32F52 y-t-al">1、拆分订单后，系统将清空该订单已打印的运单号</div>
    <div class="y-fc-F32F52 y-t-al">2、如果你开启了自动合单，无法触发拆单</div>
    <div class="y-t-ar y-mt-10">
      <el-button size="mini" @click="visible = false">取消</el-button>
      <el-button size="mini" @click="handleConfirm" type="primary">确认</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['fromParentVisible', 'targetClassName'],
  data() {
    return {
      visible: true
    }
  },
  mounted() {
    // 显示之前
    this.setPosition();
    let timer = setTimeout(() => {
      // body的click事件需要延迟注册，否则弹窗不能正常打开
      document.body.addEventListener('click', this.handleBodyClick);
      document.querySelector('.yto-x-auto.el-scrollbar__wrap').addEventListener('scroll', this.setPosition);
      timer = null;
    })
  },
  methods: {
    setPosition() {
      // 定位弹框的位置
      let curNamePositionObj = document.querySelector(this.targetClassName).getBoundingClientRect();
      let popoverDom = document.querySelector('.splitTipPopover');
      popoverDom.style.top = (curNamePositionObj.top - 30) + 'px';
      popoverDom.style.left = (curNamePositionObj.left + 50) + 'px';
    },
    handleConfirm() {
      this.$emit('splitOrderFuc')
    },
    handleBodyClick() {
      this.visible = false;
    },
  },
  watch: {
    visible(val) {
      if(!val) {
        document.body.removeEventListener('click', this.handleBodyClick);
        document.querySelector('.yto-x-auto.el-scrollbar__wrap').removeEventListener('scroll', this.setPosition);
      }
      this.$emit('update:fromParentVisible', val)
    },
  }
}
</script>
<style lang="scss" scoped>
.tiptitle {
  padding: 10px;
  text-align: left;
}
.splitTipPopover {
  position: fixed;
  font-size: 12px;
  width: 340px;
  padding: 8px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  &::after {
    content: ' ';
    width: 0;
    height: 0;
    position: absolute;
    top: 30px;
    left: -8px;
    border-top: 6px solid transparent;  
    border-bottom: 6px solid transparent;  
    border-right: 9px solid #fff;
  }
}
</style>
